export default {"src":"/_next/static/media/codex-token.32bf8ca6.svg","height":32,"width":32};